<template>
    <div :dir="$root.$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
        class="tw-min-h-[100dvh] tw-relative tw-flex tw-items-center tw-justify-center tw-p-4 tw-overflow-hidden tw-bg-gradient-to-br tw-from-slate-50 tw-via-white tw-to-primary-50/50">

        <!-- Decorative background blobs -->
        <div class="tw-pointer-events-none tw-absolute -tw-top-32 -tw-left-24 tw-w-80 tw-h-80 tw-rounded-full tw-bg-primary-200/40 tw-blur-3xl"></div>
        <div class="tw-pointer-events-none tw-absolute -tw-bottom-32 -tw-right-24 tw-w-96 tw-h-96 tw-rounded-full tw-bg-primary-300/30 tw-blur-3xl"></div>
        <div class="tw-pointer-events-none tw-absolute tw-top-1/3 tw-right-10 tw-w-40 tw-h-40 tw-rounded-full tw-bg-cyan-200/20 tw-blur-3xl"></div>

        <!-- Language switcher (hidden for now) -->
        <div v-if="false" class="tw-absolute tw-bottom-5 tw-left-5 tw-z-20">
            <AppLanguageSwitcher />
        </div>

        <!-- Login card -->
        <div class="tw-relative tw-z-10 tw-w-full tw-max-w-[430px]">
            <div class="tw-bg-white/80 tw-backdrop-blur-xl tw-border tw-border-solid tw-border-white tw-shadow-2xl tw-shadow-primary-900/10 tw-rounded-[28px] tw-p-8 sm:tw-p-10">

                <!-- Brand logo -->
                <div class="tw-flex tw-justify-center">
                    <AppLogo />
                </div>

                <h1 class="tw-text-center tw-text-2xl sm:tw-text-3xl tw-font-bold tw-text-gray-800 tw-mt-6">
                    {{ $t('pages.login.welcome') }}
                </h1>
                <p class="tw-text-center tw-text-sm tw-text-gray-500 tw-mt-2 tw-mb-8">
                    {{ $t('pages.login.welcome-paragraph') }}
                </p>

                <form @submit="login" action="">
                    <FormField v-model="user.email" input-dir="ltr" type="email" placeholder="you@example.com"
                        left-icon="solar:letter-bold-duotone" :label="$t('fields.email')"
                        :error="errors.email && $t('errors.' + errors.email, { field: $t('fields.email') })" />

                    <div class="tw-mt-3"></div>

                    <FormField v-model="user.password" input-dir="ltr" placeholder="••••••••"
                        left-icon="solar:lock-password-bold-duotone" type="password" :label="$t('fields.password')"
                        :error="errors.password && $t('errors.' + errors.password, { field: $t('fields.password') })" />

                    <div class="tw-flex tw-w-full tw-justify-end tw-mt-2">
                        <button type="button"
                            class="tw-text-primary-500 tw-text-xs tw-font-bold tw-duration-200 hover:tw-text-primary-600">
                            {{ $t('buttons.forgot-password') }}
                        </button>
                    </div>

                    <div class="tw-mt-5"></div>

                    <a-button intent="primary" :loading="isFetching" :disabled="isFetching" full
                        right-icon="solar:arrow-right-linear">
                        {{ $t('buttons.sign-in') }}
                    </a-button>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive } from 'vue';
import FormField from '@/components/form/FormField';
import AppLogo from '@/components/AppLogo';
import AppLanguageSwitcher from '@/components/AppLanguageSwitcher';
import loginService from '@/services/auth/login';

const user = reactive({ email: '', password: '' });
const { errors, isFetching, execute } = loginService(user);

const login = ($e) => {
    $e.preventDefault();
    errors.email = '';
    errors.password = '';
    if (!user.email) errors.email = 'required';
    if (!user.password) errors.password = 'required';
    if (!user.email || !user.password) return false;
    execute();
};
</script>
